"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCostComparisonText = getCostComparisonText;
function getCostComparisonText(state) {
  return state.content.text.costComparison;
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/CostComparison/selectors.js
// module id = 1152
// module chunks = 0